export default "__VITE_ASSET__rZwzkLlv__"